import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { WarningTypes } from '../../constants/edit/ArticleValidationConstants';
import ErrorsAndWarningsTooltipHeader from './ErrorsAndWarningsTooltipHeader';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const I18N_PREFIX = 'knowledgeContentUI.edit.categorize.warningsTooltip';
const HUBL_REFERENCE_ARTICLE_LINK = 'https://designers.hubspot.com/docs/hubl/intro-to-hubl#hs_cos_wrapper_widget_2878117828';
class WarningsTooltipContent extends Component {
  renderWarning(warning) {
    if (warning === WarningTypes.ESCAPE_HUBL_WARNING) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${I18N_PREFIX}.warning.${warning}`,
          options: {
            hublBrackets: '{{ }}'
          }
        }, `${warning}-message`), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          elements: {
            Link: ({
              children
            }) => /*#__PURE__*/_jsx(Link, {
              external: true,
              href: HUBL_REFERENCE_ARTICLE_LINK,
              children: children
            })
          },
          message: `${I18N_PREFIX}.warning.${warning}_jsx`
        }, `${warning}_jsx-message`)]
      });
    }
    return null;
  }
  render() {
    const {
      warnings
    } = this.props;
    if (warnings.length === 0) {
      return null;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ErrorsAndWarningsTooltipHeader, {
        iconColor: 'border-caution-default',
        langKey: `${I18N_PREFIX}.header`
      }), /*#__PURE__*/_jsx(List, {
        ordered: true,
        styled: true,
        wrapChildren: true,
        children: warnings.map(warning => /*#__PURE__*/_jsx("span", {
          children: this.renderWarning(warning)
        }, warning))
      })]
    });
  }
}
WarningsTooltipContent.propTypes = {
  warnings: PropTypes.array.isRequired
};
export default WarningsTooltipContent;